var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.75C4 4.131 6.131 2 8.75 2H17.883C17.554 0.849 16.505 0 15.25 0H3.75C2.233 0 1 1.233 1 2.75V18.25C1 19.767 2.233 21 3.75 21H4V6.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 4H8.75C7.233 4 6 5.233 6 6.75V21.25C6 22.767 7.233 24 8.75 24H20.25C21.767 24 23 22.767 23 21.25V6.75C23 5.233 21.767 4 20.25 4ZM18.25 21H10.75C10.336 21 10 20.664 10 20.25C10 19.836 10.336 19.5 10.75 19.5H18.25C18.664 19.5 19 19.836 19 20.25C19 20.664 18.664 21 18.25 21ZM18.25 17H10.75C10.336 17 10 16.664 10 16.25C10 15.836 10.336 15.5 10.75 15.5H18.25C18.664 15.5 19 15.836 19 16.25C19 16.664 18.664 17 18.25 17ZM18.25 13.5H10.75C10.336 13.5 10 13.164 10 12.75C10 12.336 10.336 12 10.75 12H18.25C18.664 12 19 12.336 19 12.75C19 13.164 18.664 13.5 18.25 13.5ZM18.25 9.5H10.75C10.336 9.5 10 9.164 10 8.75C10 8.336 10.336 8 10.75 8H18.25C18.664 8 19 8.336 19 8.75C19 9.164 18.664 9.5 18.25 9.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/record.31eb7e75dc0f370205239f42fea9dd5f.svg";
export { ForwardRef as ReactComponent };